<template>
  <b-modal
    centered
    id="config-aftersale"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
  >
    <template #modal-header="{ close }">
      <h5>Cấu hình aftersale</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div>
      <div class="form-group">
        <label>Vùng</label>
        <input v-model="region" placeholder="Vùng" disabled />
      </div>
      <div class="form-group">
        <label>Tỉnh thành</label>
        <select2-multiple-control
          v-model="cityCodes"
          :options="optionLevel2"
          :settings="{ placeholder: 'Tỉnh thành' }"
        ></select2-multiple-control>
      </div>
      <div class="form-group">
        <label>Quận huyện</label>
        <select2-multiple-control
          v-model="districtCodes"
          :options="optionLevel3"
          :settings="{ placeholder: 'Quận huyện' }"
        ></select2-multiple-control>
      </div>
      <div class="form-group">
        <label>Công việc aftersale</label>
        <select2-multiple-control
          v-model="workAS"
          :options="dataWorkAS"
          :settings="{ placeholder: 'Công việc aftersale' }"
        />
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="updateConfigAfs"> Xác nhận </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { LocationService } from '../../services/location.service'
  import Config from '@/thirdParty/config'
  export default {
    props: {
      region: {
        type: String,
        default: '',
      },
      workAS: {
        type: String,
        default: '',
      },
      idStaff: {
        type: String,
        default: '',
      },
      districtCodes: {
        type: Array,
        default: [],
      },
      cityCodes: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        Config,
        result: '22',
        dataResult: [],
        optionLevel2: [],
        optionLevel3: [],
        dataWorkAS: [],
      }
    },
    created() {
      this.getData()
      this.getData2()
    },
    methods: {
      async updateConfigAfs() {
        const data = {
          id: this.idStaff,
          countryLocations: this.districtCodes.concat(this.cityCodes),
          workAS: this.workAS,
        }
        this.$emit('updateConfigAfs', data)
      },
      onHidden() {
        this.$emit('onHidden')
      },
      async fetchDataAfs() {},
      async getData() {
        try {
          const response = await LocationService.getLocationAllLevel()
          if (response.code === 1000) {
            const dataLevel2 = response.data.filter(item => item.locationLevel === '2')
            const dataLevel3 = response.data.filter(item => item.locationLevel === '3')
            this.optionLevel2 = dataLevel2.map(item => ({
              id: item.locationCode,
              text: item.localName,
            }))
            this.optionLevel3 = dataLevel3.map(item => ({
              id: item.locationCode,
              text: item.localName,
            }))
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getData2() {
        try {
          const response = await LocationService.getAfsList()
          if (response.code === 1000) {
            this.dataWorkAS = response.data.map(item => ({ id: item.code, text: item.value }))
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style scoped></style>
